import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import TabletConfirmedSlot from './TabletConfirmedSlot'

export default function TabletSlotPage ({ box, slot, onCancel, slotStatus }) {
  return (
    <>
      <PublicSiderXS />
      <TabletConfirmedSlot box={box} slot={slot} onCancel={onCancel} slotStatus={slotStatus} />
    </>
  )
}
